export const navigationFr = {
  navigation: {
    titlebar: {
      logout: 'Déconnexion',
    },
    general: 'Général',
    external: 'Partenaires intégrés',
    apps: 'Applications',
    user: "Nom d'utilisateur",
    home: 'Accueil',
    sites: {
      root: 'Sites',
    },
    announcements: {
      root: 'Annonces',
    },
    discounts: {
      root: 'Réductions',
    },
    adminPanel: {
      nav: 'Administration',
      userManagement: {
        root: 'Utilisateurs',
      },
    },
    orders: {
      root: 'Commandes',
    },
    menus: {
      root: 'Menus',
      global: 'Menus globaux',
      local: 'Menus locaux',
      stock: 'Gérer le stock',
    },
    libraries: {
      root: 'Bibliothèques',
    },
    reports: {
      root: 'Rapports',
      salesSummary: 'Résumé des ventes',
      salesDistribution: 'Répartition des ventes',
      salesMix: 'Mélange des ventes',
      refundReport: 'Remboursements',
      terminalSales: 'Ventes terminales',
      salesReading: 'Lecture des ventes',
    },
    operatorAnalytics: {
      root: 'Analyse des opérateurs',
    },
    scanner: {
      root: 'Scanneur de codes-barres',
    },
    forecasting: {
      root: 'Prévisions',
    },
    logout: {
      root: 'Déconnexion',
    },
    inventory: {
      root: 'Inventaire',
      desktop: 'Bureau',
      mobile: 'Mobile',
    },
    labs: {
      root: 'Laboratoires',
    },
    discover: {
      root: 'Découvrir',
    },
  },
};